<template>
    <div>
        <b-modal 
            no-stacking
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            hide-footer
            v-model="kerryDropoff.show"
            size="xl"
        >
        <template slot="modal-header">
            <div slot="header" class="bg-white border-0 w-100">
                <div class="row align-items-center">
                    <div class="col-6">
                        <h3 class="mb-0">นำเข้าพัสดุ 
                            {{ kerryDropoff.code == "KRYDS" ? 'Kerry Dropoff ' : 'Orange Dropoff' }}
                        <span class="text-danger"></span></h3>
                    </div>
                    <div class="col-6 text-right">
                        <a :href="customDropoff.manual" v-if="customDropoff.manual" target="_blank">คู่มือการใช้งาน  </a>  
                        <a :href="customDropoff.vdoHowTo"  v-if="customDropoff.vdoHowTo" target="_blank">VDO การใช้งาน</a>
                    </div>
                </div>
            </div>
        </template>
            <card shadow type="secondary" class="m--4">
                <div class="row">
                    <div class="col-md-12">
                        <ScanTrackingKerryDropoff
                            ref="kerryDropoff"
                            :isLoading="kerryDropoff.isLoadingKerryDropoff"
                            isPlaceholder="SDOF1234567890"
                            :isError="kerryDropoff"
                            :isTracking="kerryDropoff"
                            courierCode="KRYDS"
                            :listSize="listSize"
                            :shopId="shopId"
                            @checkTracking="checkTrackingKerryDropoff()"
                            @checkTrackingRegx="checkTrackingRegx( $event )"
                        />
                        <div class="container-fluid px-5">
                            <div class="row">
                                <h4>รายการพัสดุ</h4>    
                            </div>
                            <div class="row">
                                <div class="scroll-table scroll-bar-pop m-h-380 scrollbar-style table-responsive">
                                    <!-- <h4 class="scroll-empty text-center">กรุณาแสกนหมายเลขพัสดุ</h4> -->
                                    <table class="table">
                                        <thead class="thead-light">
                                            <tr class="text-center">
                                                <th>#</th>
                                                <th>Tracking no.</th>
                                                <th>น้ำหนัก {{ $THEME.unitKG ? '( กิโลกรัม )' : '( กรัม )' }}</th>
                                                <th>ขนาดพัสดุ (เซนติเมตร)</th>
                                                <th>จัดการ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(item,index) in kerryOrder">
                                                <tr class="text-center table-white" :key="index">
                                                    <td>{{index + 1}}</td>
                                                    <td>{{item.dropoff_tracking_code}}</td>
                                                    <td>{{ ($THEME.unitKG) ? (item.parcel.weight/1000) : item.parcel.weight }}</td>
                                                    <td>{{item.parcel.width+'x'+item.parcel.length+'x'+item.parcel.height}}</td>
                                                    <td>
                                                        <div class="d-flex">
                                                            <button
                                                                class="btn btn-link text-danger p-2 hvr-grow"
                                                                @click="deleteKerryOrder( index )"
                                                            >
                                                                <i class="far fa-trash-alt"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="mt-4 w-100">
                                <div class="row text-center">
                                    <div class="col-12">
                                        <b-button 
                                            class="px-5 mx-4" 
                                            variant="secondary"
                                            @click="clearKerryDropoff()"
                                        > 
                                            <i class="fas fa-circle-notch fa-spin" v-if="isLoadCancelBatch"></i>
                                            ยกเลิก
                                        </b-button>
                                        <b-button
                                            class="px-5 mx-4"
                                            variant="success"
                                            @click="$emit('confirmCreateKerryDropoff' , kerryOrder)"
                                        > ยืนยัน
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </card>
        </b-modal>
    </div>
</template>

<script>
import ScanTrackingKerryDropoff from '@/components/custom/pos/ScanTrackingKerryDropoff'
import customTheme from "@/config/POPTheme";
import { sound } from '@/plugins/soundEffect.js'
import { searchTrackingKerryDropoff } from "@/axios/search.js";

export default {
    name: 'KerryDropoff' ,
    props: {
        kerryDropoff: Object,
        count: Number,
        addressFrom: Object,
        cartKerryDropoff: Array,
        listSize: Object,
        shopId: [Number, String]
    },
    components:{
        ScanTrackingKerryDropoff
    },
    data(){
        const dropoffKerryOption = customTheme.dropoffKerryOption || {}
        return {
            isLoadCancelBatch: false,
            kerryOrder: [],
            batchId: '',
            customDropoff: {
                manual: dropoffKerryOption.manual,
                vdoHowTo: dropoffKerryOption.vdoHowTo,
                limit: dropoffKerryOption.limit
            }
        }
    },
    methods:{
        async checkTrackingKerryDropoff(){
            this.kerryDropoff.isLoadingKerryDropoff = true
            this.kerryDropoff.errorMsg = '';

            if( (this.kerryOrder.length+this.cartKerryDropoff.length) > this.customDropoff.limit-1 ){
                sound('beepFail')
                this.kerryDropoff.errorMsg = `ไม่สามารถสร้างรายการ Shipment ได้ เนื่องจาก BatchId รองรับจำนวน Shipment ได้สูงสุด ` + this.customDropoff.limit + ` Shipment`;
                this.kerryDropoff.isLoadingKerryDropoff = false
                return false
            }

            let uniqueTracking = this.kerryOrder.filter( kerry => {
                return kerry.dropoff_tracking_code === this.kerryDropoff.trackingCode
            })
            let uniqueCartTracking = this.cartKerryDropoff.filter( kerry => {
                return kerry.dropoff_tracking_code === this.kerryDropoff.trackingCode
            })

            if( uniqueTracking.length > 0 || uniqueCartTracking.length > 0 ){
                sound('beepFail')
                this.kerryDropoff.errorMsg = `ไม่สามารถสร้างรายการ Shipment ได้ เนื่องจากหมายเลขพัสดุ ${this.kerryDropoff.trackingCode} นี้ ถูกใช้งานไปแล้ว`;
                this.kerryDropoff.isLoadingKerryDropoff = false
                return false
            }
            await searchTrackingKerryDropoff( this.kerryDropoff.trackingCode ).then(() => {
                sound('positiveBeep')
                this.kerryOrder.push( this.setFormatOrderKerryDropoff( this.kerryDropoff.trackingCode ) );

                this.clearForm();
                this.$refs.kerryDropoff.$refs.searchTracking.focus();
            }).catch(e => {
                sound('beepFail')
                this.kerryDropoff.errorMsg = e;
                this.kerryDropoff.isLoadingKerryDropoff = false
            });
        },
        async deleteKerryOrder( indexOfOrder ){
            this.kerryOrder.splice( indexOfOrder , 1)
        },
        async clearKerryDropoff(){
            this.kerryOrder = [];
            this.kerryDropoff.show = false
            this.kerryDropoff.size.boxSize = '';
            this.clearForm()
        },
        clearForm(){
            this.kerryDropoff.isLoadingKerryDropoff = false
            this.kerryDropoff.trackingCode = '';
            this.kerryDropoff.errorMsg = '';
            if( !this.kerryDropoff.favoriteDimension ){
                Object.keys(this.kerryDropoff.parcel).forEach(key => {
                    if( !['weight', 'weightKG'].includes(key) ){
                        this.kerryDropoff.parcel[key] = ''
                    }
                });
                this.kerryDropoff.size.boxSize = '';
            }       
          
            if( !this.kerryDropoff.favoriteWeight ){
                this.kerryDropoff.parcel.weight = ''
                this.kerryDropoff.parcel.weightKG = ''
            }

            this.$refs.kerryDropoff.clearValidate();
        },
        setFormatOrderKerryDropoff( kerryTrackingCode ){
            let count = this.count

            let kerryDropoff = {
                error:{
                    status: false,
                    data: [],
                    msg: null
                },
                type : 'ship',
                dropoff_type : (this.kerryDropoff.code == "KRYDS") ? 'KERRY_DROPOFF' : 'ORANGE_DROPOFF',
                num : 1,
                name : (this.kerryDropoff.code == "KRYDS") ? 'KERRY DROPOFF' : 'ORANGE DROPOFF',
                key: this.kerryDropoff.code, 
                parcel: {
                    weight: (this.$THEME.unitKG) ? (this.kerryDropoff.parcel.weight*1000) : this.kerryDropoff.parcel.weight,
                    width: this.kerryDropoff.parcel.width,
                    length: this.kerryDropoff.parcel.length,
                    height: this.kerryDropoff.parcel.height,
                    key_size: '',
                    weightKG: this.kerryDropoff.parcel.weight,
                },
                price : '0.00',
                rate_remote_area : '0.00',
                cross_price : '0.00',
                cod_amount : '0.00',
                dropoff_tracking_code: kerryTrackingCode,
                consignment_no_ref: '',
                check : count++,
                from: {
                    name: this.addressFrom.name,
                    address: this.addressFrom.address,
                    district: this.addressFrom.district,
                    state: this.addressFrom.state,
                    province: this.addressFrom.province,
                    postcode: this.addressFrom.postcode,
                    tel: this.addressFrom.tel
                },
                to: {
                    name: kerryTrackingCode,
                    address: '-',
                    district: '-',
                    province: '-',
                    state:'-',
                    postcode: '10000',
                    tel: '-',
                }
            }

            this.$emit('update:count', count)

            return kerryDropoff
        },
        checkTrackingRegx( event ) {
            this.kerryDropoff.trackingCode = event.target.value.toUpperCase()
             if (this.kerryDropoff.trackingCode)
                this.kerryDropoff.trackingCode = this.kerryDropoff.trackingCode.trim().split(' ')[0]
            let validateBarcode = /^(KERDO|KERCRD|SSDOF|SDOF|SDOFRTN|TIK|JDOF)[0-9a-zA-Z]+$/i.test(this.kerryDropoff.trackingCode)
            if( validateBarcode === false ){
                this.kerryDropoff.errorMsg = 'ไม่พบหมายเลขพัสดุดังกล่าว';
                return false;
            }
        }
    }
}
</script>
